<template>
  <g>
    <path
      d="M8.62618 24.2944C5.63798 24.2944 3.20068 21.8571 3.20068 18.8689C3.20068 15.8807 5.63798 13.4434 8.62618 13.4434C11.6144 13.4434 14.0517 15.8807 14.0517 18.8689C14.0517 21.8571 11.6144 24.2944 8.62618 24.2944ZM8.62618 15.1127C6.55614 15.1127 4.87007 16.7988 4.87007 18.8689C4.87007 20.9389 6.55614 22.625 8.62618 22.625C10.6962 22.625 12.3823 20.9389 12.3823 18.8689C12.3823 16.7988 10.6962 15.1127 8.62618 15.1127Z"
      :fill="iconColor"
    />
    <path
      d="M23.3762 24.2944C20.388 24.2944 17.9507 21.8571 17.9507 18.8689C17.9507 15.8807 20.388 13.4434 23.3762 13.4434C26.3644 13.4434 28.8017 15.8807 28.8017 18.8689C28.8017 21.8571 26.3644 24.2944 23.3762 24.2944ZM23.3762 15.1127C21.3061 15.1127 19.6201 16.7988 19.6201 18.8689C19.6201 20.9389 21.3061 22.625 23.3762 22.625C25.4462 22.625 27.1323 20.9389 27.1323 18.8689C27.1323 16.7988 25.4462 15.1127 23.3762 15.1127Z"
      :fill="iconColor"
    />
    <path
      d="M23.232 19.85H15.9952C15.678 19.85 15.3859 19.6663 15.244 19.3742L11.3543 11.3111C11.2291 11.0523 11.2458 10.7518 11.3961 10.5014C11.5463 10.2594 11.8134 10.1091 12.1056 10.1091H19.3423C19.6595 10.1091 19.9517 10.2928 20.0936 10.5849L23.9916 18.6564C24.1168 18.9151 24.1001 19.2156 23.9498 19.466C23.7829 19.6997 23.5158 19.85 23.232 19.85ZM16.5211 18.1806H21.9048L18.8165 11.7785H13.4327L16.5211 18.1806Z"
      :fill="iconColor"
    />
    <path
      d="M8.2086 19.8536C8.09175 19.8536 7.97489 19.8285 7.86638 19.7785C7.44904 19.5865 7.2654 19.094 7.44904 18.6767L12.3153 7.96756C12.4488 7.66707 12.7493 7.4751 13.0749 7.4751H15.0197C15.4788 7.4751 15.8544 7.85071 15.8544 8.30979C15.8544 8.76887 15.4788 9.14448 15.0197 9.14448H13.6091L8.96817 19.3611C8.82628 19.6699 8.52579 19.8536 8.2086 19.8536Z"
      :fill="iconColor"
    />
    <path
      d="M20.662 9.1396H18.2998C17.8407 9.1396 17.4651 8.76399 17.4651 8.30491C17.4651 7.84583 17.8407 7.47021 18.2998 7.47021H20.662C21.121 7.47021 21.4966 7.84583 21.4966 8.30491C21.4966 8.77233 21.121 9.1396 20.662 9.1396Z"
      :fill="iconColor"
    />
    <path
      d="M16.0398 19.5383C15.9313 19.5383 15.8312 19.5216 15.7227 19.4798C15.297 19.3045 15.0883 18.8204 15.2636 18.3947L18.2852 10.9827C18.4605 10.557 18.9446 10.3483 19.3703 10.5236C19.796 10.6989 20.0046 11.183 19.8293 11.6087L16.8078 19.0208C16.6742 19.3463 16.3654 19.5383 16.0398 19.5383Z"
      :fill="iconColor"
    />
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "#ee1c25"
    }
  }
};
</script>
